import { useMutation } from '@tanstack/react-query';

import { storesApi } from '../api/stores-api';

/** Queues a rebuild of the store's shopper search index; the 202 is the whole result. */
export function useReindexSearch(storeId: string) {
  return useMutation({
    mutationFn: () => storesApi.reindexSearch(storeId),
    meta: { successMessage: 'stores:search.queued' },
  });
}
